/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_No_MatchesInputs */

const bn_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোন মিল নেই`)
};

const de_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Übereinstimmungen`)
};

const el_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χωρίς αγώνες`)
};

const en_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matches`)
};

const es_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay coincidencias`)
};

const fr_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat`)
};

const hi_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई मेल नहीं`)
};

const hu_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs egyezés`)
};

const id_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada kecocokan`)
};

const it_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna corrispondenza`)
};

const ja_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一致しません`)
};

const ko_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일치하는 항목 없음`)
};

const nl_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen overeenkomsten`)
};

const pl_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak dopasowań`)
};

const pt_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma correspondência`)
};

const ru_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет совпадений`)
};

const sv_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga matchningar`)
};

const tr_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eşleşme yok`)
};

const uk_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає збігів`)
};

const vi_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có kết quả phù hợp`)
};

const zh_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有匹配项`)
};

const zh_hant_game_no_matches = /** @type {(inputs: Game_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有匹配項`)
};

/**
* | output |
* | --- |
* | "No matches" |
*
* @param {Game_No_MatchesInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_no_matches = /** @type {((inputs?: Game_No_MatchesInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_No_MatchesInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_no_matches(inputs)
	if (locale === "de") return de_game_no_matches(inputs)
	if (locale === "el") return el_game_no_matches(inputs)
	if (locale === "en") return en_game_no_matches(inputs)
	if (locale === "es") return es_game_no_matches(inputs)
	if (locale === "fr") return fr_game_no_matches(inputs)
	if (locale === "hi") return hi_game_no_matches(inputs)
	if (locale === "hu") return hu_game_no_matches(inputs)
	if (locale === "id") return id_game_no_matches(inputs)
	if (locale === "it") return it_game_no_matches(inputs)
	if (locale === "ja") return ja_game_no_matches(inputs)
	if (locale === "ko") return ko_game_no_matches(inputs)
	if (locale === "nl") return nl_game_no_matches(inputs)
	if (locale === "pl") return pl_game_no_matches(inputs)
	if (locale === "pt") return pt_game_no_matches(inputs)
	if (locale === "ru") return ru_game_no_matches(inputs)
	if (locale === "sv") return sv_game_no_matches(inputs)
	if (locale === "tr") return tr_game_no_matches(inputs)
	if (locale === "uk") return uk_game_no_matches(inputs)
	if (locale === "vi") return vi_game_no_matches(inputs)
	if (locale === "zh") return zh_game_no_matches(inputs)
	return zh_hant_game_no_matches(inputs)
});